import {Component, ElementRef, Input, SimpleChanges} from '@angular/core';
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { areJSONEqual } from '../../../utils/helper';

@Component({
  selector: 'simple-pie-chart',
  templateUrl: './simple-pie-chart.component.html',
  styleUrl: './simple-pie-chart.component.scss'
})
export class SimplePieChartComponent {

  @Input() props: any
  @Input() innerRadius: number = 0
  @Input() color: any;
  private root!: am5.Root;
  private chartData: any = []

  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewInit(): void {
    this.implementBarChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    let curr_data = changes['props'].currentValue
    let prev_data = changes['props'].previousValue

    if (!areJSONEqual(curr_data[0], prev_data ? prev_data[0] : {})) {
      this.updateChartData(curr_data)
    }
  }

  updateChartData(newData: any): void {
    if (!this.root) return;

    const chart = this.root.container.children.values[0] as am5percent.PieChart;
    if (!chart) return;

    const series = chart.series.values[0] as am5percent.PieSeries;
    if (!series) return;

    this.chartData = newData;

    series.data.setAll(this.chartData);

    const legend = chart.children.values.find(child => child instanceof am5.Legend) as am5.Legend;
    if (legend) {
      legend.data.setAll(series.dataItems);
    }

    series.appear(1000, 100);
  }

  implementBarChart() {
    // Create root element
    this.root = am5.Root.new(this.elementRef.nativeElement.querySelector('#chartdiv'));

    // Set themes
    this.root.setThemes([am5themes_Animated.new(this.root)]);

    // Create chart
    let chart = this.root.container.children.push(
      am5percent.PieChart.new(this.root, {
        layout: this.root.horizontalLayout
      })
    );

    // Create series
    let series = chart.series.push(
      am5percent.PieSeries.new(this.root, {
        name: "Series",
        categoryField: "category",
        valueField: "value",
        alignLabels: true,
        innerRadius: am5.percent(this.innerRadius)
      })
    );

    series.labels.template.set("forceHidden", true);
    series.ticks.template.set("forceHidden", true);

    const colors = this.color.map((hexColor: string | number) => am5.color(hexColor)); // Convert hex strings to am5.Color objects
    const colorSet = am5.ColorSet.new(this.root, {
      colors: colors // Apply the dynamically generated colors
    });
    series.set("colors", colorSet);

    // Set initial data from props
    this.chartData = this.props || [];
    series.data.setAll(this.chartData);

    // Add legend
    let legend = chart.children.push(am5.Legend.new(this.root, {
      y: am5.percent(50),
      centerY: am5.percent(50),
      layout: this.root.verticalLayout
    }));

    legend.data.setAll(series.dataItems);

    // This will add a bottom margin to each legend item, creating a vertical gap.
    legend.itemContainers.template.setAll({
        marginBottom: 15 // Adjust this value to increase or decrease the gap
    });

    // Configure legend markers to be small bullets
    legend.markerRectangles.template.setAll({
        cornerRadiusTL: 10, // Make corners rounded for a circular appearance
        cornerRadiusTR: 10,
        cornerRadiusBL: 10,
        cornerRadiusBR: 10
    });
    legend.markerRectangles.template.setAll({
      width: 12,  // Set width of the marker
      height: 12, // Set height of the marker
      // radius: 5, // Not directly supported on markerRectangles, use cornerRadius for circles
    });

    // Increase legend text size and set color
    legend.labels.template.setAll({
      fontSize: 16, // Adjust font size as needed
      fill: am5.color('#d10f59') // Set text color to black (you can change this hex code)
    });

    // Add some animation when first appearing
    series.appear(1000, 100);
  }
  ngOnDestroy(): void {
    if (this.root) {
      this.root.dispose();
    }
  }

}
